// BORRADOR: revisa este texto (idealmente con un abogado) antes de publicarlo.
// Cuando esté aprobado, cambia isDraft a false para ocultar la etiqueta "Borrador".
export const privacyPolicy = {
  isDraft: true,
  title: 'Política de privacidad',
  updated: 'Última actualización: [fecha de publicación]',
  intro:
    'En JSEEFECT respetamos tu privacidad. Esta política explica qué datos recopilamos cuando completas nuestro formulario, para qué los usamos, cómo los protegemos y cómo puedes pedir que los eliminemos.',
  sections: [
    {
      heading: 'Quiénes somos',
      paragraphs: [
        'JSEEFECT es responsable de los datos personales que nos compartes a través de este sitio web. Para cualquier pregunta sobre privacidad puedes escribirnos por WhatsApp al +1 (689) 299-5809 o al correo [tu correo de contacto].',
      ],
    },
    {
      heading: 'Qué datos recopilamos mediante Tally',
      paragraphs: [
        'Nuestro formulario de asesoría gratuita funciona con Tally (tally.so), una plataforma externa de formularios. Cuando lo completas, podemos recopilar:',
      ],
      list: [
        'Datos de contacto: nombre, correo electrónico y número de teléfono.',
        'Ubicación general: ciudad y estado.',
        'Tus respuestas al formulario: objetivos, nivel de experiencia, obstáculos actuales y cualquier información adicional que decidas compartir.',
        'Datos técnicos básicos que Tally registra de forma automática, como la fecha y hora del envío y el tipo de dispositivo o navegador.',
      ],
      after:
        'Te pedimos no incluir información médica detallada ni otros datos sensibles en el formulario, salvo que sea estrictamente necesario para tu solicitud.',
    },
    {
      heading: 'Para qué utilizamos tus datos',
      list: [
        'Revisar tu solicitud y entender tu punto de partida.',
        'Contactarte por WhatsApp, correo electrónico o teléfono con el siguiente paso.',
        'Preparar recomendaciones adaptadas a tu situación.',
        'Mejorar nuestro sitio y nuestros servicios de forma general.',
      ],
      after: 'No usamos tus datos para fines distintos a los descritos aquí y nunca los vendemos ni los alquilamos.',
    },
    {
      heading: 'Con quién compartimos tus datos',
      paragraphs: [
        'Solo compartimos tu información con los proveedores necesarios para operar el servicio, como Tally (formulario) y las herramientas que usamos para comunicarnos contigo. Estos proveedores tratan tus datos según sus propias políticas de privacidad y medidas de seguridad. También podríamos compartirlos si la ley nos lo exige.',
      ],
    },
    {
      heading: 'Cómo protegemos tu información',
      list: [
        'Tally transmite los datos del formulario mediante conexiones cifradas (HTTPS).',
        'El acceso a las respuestas está limitado al equipo de JSEEFECT que las necesita para atender tu solicitud.',
        'Usamos contraseñas seguras y verificación en dos pasos en las cuentas donde guardamos tu información.',
      ],
      after:
        'Ningún sistema en internet es 100% seguro, pero tomamos medidas razonables para proteger tus datos contra accesos no autorizados, pérdida o uso indebido.',
    },
    {
      heading: 'Cuánto tiempo conservamos tus datos',
      paragraphs: [
        'Conservamos tu información mientras sea necesaria para atender tu solicitud y darte seguimiento, y como máximo durante [12 meses] desde tu último contacto con nosotros, salvo que la ley nos obligue a conservarla por más tiempo.',
      ],
    },
    {
      heading: 'Cómo solicitar la eliminación de tus datos',
      paragraphs: [
        'Puedes pedirnos en cualquier momento que accedamos, corrijamos o eliminemos tus datos personales. Para hacerlo:',
      ],
      list: [
        'Escríbenos por WhatsApp al +1 (689) 299-5809 o al correo [tu correo de contacto].',
        'Indica tu nombre y el correo o teléfono que usaste en el formulario, con el mensaje “Eliminar mis datos”.',
        'Eliminaremos tu información de nuestros registros y de Tally, y te confirmaremos el proceso en un plazo máximo de [30 días].',
      ],
      after:
        'Si vives en un estado con leyes de privacidad específicas, como California, también puedes ejercer los derechos adicionales que esas leyes te otorgan.',
    },
    {
      heading: 'Menores de edad',
      paragraphs: [
        'Nuestro formulario no está dirigido a menores de 18 años y no recopilamos intencionalmente información de menores. Si crees que un menor nos envió sus datos, escríbenos y los eliminaremos.',
      ],
    },
    {
      heading: 'Cambios a esta política',
      paragraphs: [
        'Podemos actualizar esta política cuando sea necesario. La versión vigente siempre estará disponible en este sitio con su fecha de actualización.',
      ],
    },
  ],
} as const
